module.exports = __webpack_public_path__ + "static/img/googleplay.d9958e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/googleplay.png
// module id = LFO7
// module chunks = 1